
























































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import {
  LanguageDto,
  UserDto,
  AppGroupDto,
  MetadataConfiguration,
  UserTypeDto,
  MetadataConfigurationComposer,
  EntityDto
} from "@/server/app.dtos";
import ConfigsService from "@/services/api/configs.service";
import { UsersService } from "@/services/api/users.service";
import {
  EditUserCommand,
  EditUserMetadataCommand
} from "@/server/app.commands";
import { NotificationServiceBus } from "@/services/bus/notifications.service";
import {
  GetEntityFilesDtosQuery,
  GetUserMetadataDtoQuery,
  GetUsersDtosOrderOptions,
  GetUsersDtosQuery
} from "@/server/app.queries";
import { ListResponse } from "@/models/grids/list.response";
import SingleImageUploaderComponent from "@/components/uploaders/SingleImageUploader.vue";
import EntitiesService from "@/services/api/entities.service";
import nationalities from "@/models/storage/nationalities";

@Component({
  components: {
    SingleImageUploader: SingleImageUploaderComponent
  }
})
export default class UserEditPage extends Vue {
  @Prop() user!: UserDto;
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
  instance!: EditUserCommand;
  usersService: UsersService = new UsersService();
  entitieservice: EntitiesService = new EntitiesService();
  configsService: ConfigsService = new ConfigsService();
  users: UserDto[] | null = null;
  entities: EntityDto[] | null = null;
  metadata: MetadataConfiguration | null = null;
  appGroups: AppGroupDto[] | null = null;
  userTypes: UserTypeDto[] | null = null;
  nationalities: string[] = nationalities;
  submitButton :string = "submit-btn";
  tabs: string[] = ["Dados Gerais", "Atributos"];
  currentTab: string = "general";
  isLoading: boolean = false;
  isValid: boolean = false;

  async created() {
    this.instance = new EditUserCommand();
    this.instance.init(this.user);
    this.instance.appGroups = [];
    if (this.user.appGroups) {
      this.user.appGroups.forEach(i =>
        this.instance?.appGroups?.push(i.idAppGroup || 1)
      );
    }
    await this.LoadRelatedData();
  }

  async LoadRelatedData() {
    const query: string = "IdLanguage=" + this.currentLanguage.idLanguage;

    // Load App Groups
    await this.configsService.Load("api/appgroups", query).then(result => {
      this.appGroups = result;
    });

    // Load UserTypes
    await this.configsService.Load("api/userTypes", query).then(result => {
      this.userTypes = result;
    });

    // Load Users
    const usersQuery = new GetUsersDtosQuery();
    usersQuery.idLanguage = this.currentLanguage.idLanguage;
    usersQuery.orderBy = GetUsersDtosOrderOptions.NameAsc;
    await this.usersService
      .GetList(usersQuery)
      .then((response: ListResponse<UserDto>) => (this.users = response.data));

    // Load Entities
    const entitiesQuery = new GetEntityFilesDtosQuery();
    entitiesQuery.idLanguage = this.currentLanguage.idLanguage;
    await this.entitieservice
      .GetList(entitiesQuery)
      .then(
        (response: ListResponse<EntityDto>) => (this.entities = response.data)
      );

    // Load Metadata
    const metadataQuery = new GetUserMetadataDtoQuery();
    metadataQuery.idUser = this.user.idUser;
    metadataQuery.idLanguage = this.currentLanguage.idLanguage;
    await this.usersService
      .GetMetadata(metadataQuery)
      .then((response: MetadataConfiguration) => (this.metadata = response));
  }

  onSelectPhoto(file: string): void {
    this.instance.photo = file;
  }

  async onEditUser() {
    if (this.isLoading) return;
    this.isLoading = true;
    await this.usersService
      .Edit(this.instance)
      .then((id: number) => {
        NotificationServiceBus.showSuccessMessage(
          "Sucesso",
          "Operação efetuada com sucessso"
        );
        this.$router.push(`/user/${id}/dashboard`);
      })
      .catch((error: any) => NotificationServiceBus.showError(error))
      .finally(() => (this.isLoading = false));
  }

  async onEditMetatada(data: MetadataConfigurationComposer) {
    if (this.isLoading) return;
    this.isLoading = true;
    const command = new EditUserMetadataCommand();
    command.idUser = this.user.idUser;
    command.metadata = data.metadata;
    await this.usersService
      .EditMetadata(command)
      .then((id: number) => {
        NotificationServiceBus.showSuccessMessage(
          "Sucesso",
          "Operação efetuada com sucessso"
        );
        this.$router.push(`/user/${id}/dashboard`);
      })
      .catch((error: any) => NotificationServiceBus.showError(error))
      .finally(() => (this.isLoading = false));
  }
}
